import { cn } from '@/lib/utils'
import { Typo3Image } from '@/types'
import {
  BaseLink,
  ButtonIcon,
  Chip,
  Img,
  Richtext,
  Title
} from '@/ui/components'
import { MEDIA } from '@spot'
import { BaseLinkProps } from '../types'

interface CardBlogProps extends Omit<BaseLinkProps, 'role'> {
  isLarge?: boolean
  title?: string
  overline?: string
  description?: string
  image?: Typo3Image
  useCursor?: boolean
}

const CardBlog = ({
  isLarge = false,
  title,
  overline,
  description,
  image,
  className,
  useCursor = true,
  ...props
}: CardBlogProps) => {
  const cardClasses = cn(
    'group bg-neutral-200 flex flex-col h-full relative',
    isLarge && '',
    className
  )

  return (
    <BaseLink className={cardClasses} {...props}>
      <div
        className={cn(
          'relative aspect-square overflow-hidden',
          isLarge ? 'md:aspect-video' : 'md:aspect-rect'
        )}
      >
        {image && (
          <Img
            priority={isLarge}
            className={cn('image-hover-effect h-full w-full')}
            data={image}
            sizes={`${MEDIA.tablet} 22rem, ${isLarge ? `84rem` : `25rem`}`}
            objectCover
            fill
          />
        )}

        <div
          className={cn(
            'gap-xs absolute bottom-0 left-0 flex justify-center',
            isLarge ? 'md:right-0' : ''
          )}
        >
          <Chip size="s" className="">
            {overline}
          </Chip>
        </div>
      </div>
      <div
        className={cn(
          'gap-y-md p-lg pb-padding-md place-items-center-start duration-(duration-default) ease-out-cubic grid auto-rows-auto grid-cols-1 transition-opacity data-[hover=true]:opacity-75 md:justify-items-start'
        )}
      >
        {/* {overline && <p className="text-neutral-400">{overline}</p>} */}
        <div
          className={cn(
            'gap-y-xs flex flex-col',
            isLarge
              ? 'md:mx-auto md:max-w-250 md:items-center md:text-center md:text-balance'
              : ''
          )}
        >
          <Title className={cn('line-clamp-3', isLarge ? 'h3 md:h2' : 'h3')}>
            {title}
          </Title>
          {description && (
            <Richtext
              text={description}
              className="textstyle-md-regular line-clamp-3 text-neutral-600"
            />
          )}
        </div>
      </div>
      <ButtonIcon
        icon="material-symbols:add"
        variant="filled-accent"
        className="absolute right-0 bottom-0 scale-80 opacity-0 group-hover:scale-100 group-hover:opacity-100"
      />
    </BaseLink>
  )
}

CardBlog.displayName = 'CardBlog'

export default CardBlog
